export default {"src":"/_next/static/media/LogoIpsum.cfc6e79c.svg","height":33,"width":135,"blurWidth":0,"blurHeight":0};